import { Link } from 'react-router-dom';
import { articlesList } from '@/mocks/articles';

export default function ArticlesGrid() {
  return (
    <section className="bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Latest Vigorbuy Spreadsheet Guides
          </h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">
            Expert-written articles to help you discover products, compare prices, and shop smarter with the Vigorbuy Spreadsheet
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articlesList.map((article) => (
            <Link
              key={article.slug}
              to={`/articles/${article.slug}`}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-background-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-white/90 text-foreground-950 text-xs font-semibold backdrop-blur-sm">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-2 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 mb-3 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                  <span className="text-xs font-medium text-primary-600 flex items-center gap-1 group-hover:gap-2 transition-all">
                    Read More <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/articles/vigorbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-950 text-white text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors"
          >
            Browse All Guides
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}